export const eventBindMarkComplete = "mark-ad__mark-complete"
